var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Protocol } from '@uniswap/router-sdk';
// This file is lazy-loaded, so the import of smart-order-router is intentional.
// eslint-disable-next-line no-restricted-imports
import { routeAmountsToString } from '@uniswap/smart-order-router';
// from routing-api (https://github.com/Uniswap/routing-api/blob/main/lib/handlers/quote/quote.ts#L243-L311)
export function transformSwapRouteToGetQuoteResult(type, amount, _a) {
    var e_1, _b;
    var quote = _a.quote, quoteGasAdjusted = _a.quoteGasAdjusted, route = _a.route, estimatedGasUsed = _a.estimatedGasUsed, estimatedGasUsedQuoteToken = _a.estimatedGasUsedQuoteToken, estimatedGasUsedUSD = _a.estimatedGasUsedUSD, gasPriceWei = _a.gasPriceWei, methodParameters = _a.methodParameters, blockNumber = _a.blockNumber;
    var routeResponse = [];
    try {
        for (var route_1 = __values(route), route_1_1 = route_1.next(); !route_1_1.done; route_1_1 = route_1.next()) {
            var subRoute = route_1_1.value;
            var amount_1 = subRoute.amount, quote_1 = subRoute.quote, tokenPath = subRoute.tokenPath;
            if (subRoute.protocol === Protocol.V3) {
                var pools = subRoute.route.pools;
                var curRoute = [];
                for (var i = 0; i < pools.length; i++) {
                    var nextPool = pools[i];
                    var tokenIn = tokenPath[i];
                    var tokenOut = tokenPath[i + 1];
                    var edgeAmountIn = undefined;
                    if (i === 0) {
                        edgeAmountIn = type === 'exactIn' ? amount_1.quotient.toString() : quote_1.quotient.toString();
                    }
                    var edgeAmountOut = undefined;
                    if (i === pools.length - 1) {
                        edgeAmountOut = type === 'exactIn' ? quote_1.quotient.toString() : amount_1.quotient.toString();
                    }
                    curRoute.push({
                        type: 'v3-pool',
                        tokenIn: {
                            chainId: tokenIn.chainId,
                            decimals: tokenIn.decimals,
                            address: tokenIn.address,
                            symbol: tokenIn.symbol,
                        },
                        tokenOut: {
                            chainId: tokenOut.chainId,
                            decimals: tokenOut.decimals,
                            address: tokenOut.address,
                            symbol: tokenOut.symbol,
                        },
                        fee: nextPool.fee.toString(),
                        liquidity: nextPool.liquidity.toString(),
                        sqrtRatioX96: nextPool.sqrtRatioX96.toString(),
                        tickCurrent: nextPool.tickCurrent.toString(),
                        amountIn: edgeAmountIn,
                        amountOut: edgeAmountOut,
                    });
                }
                routeResponse.push(curRoute);
            }
            else if (subRoute.protocol === Protocol.V2) {
                var pools = subRoute.route.pairs;
                var curRoute = [];
                for (var i = 0; i < pools.length; i++) {
                    var nextPool = pools[i];
                    var tokenIn = tokenPath[i];
                    var tokenOut = tokenPath[i + 1];
                    var edgeAmountIn = undefined;
                    if (i === 0) {
                        edgeAmountIn = type === 'exactIn' ? amount_1.quotient.toString() : quote_1.quotient.toString();
                    }
                    var edgeAmountOut = undefined;
                    if (i === pools.length - 1) {
                        edgeAmountOut = type === 'exactIn' ? quote_1.quotient.toString() : amount_1.quotient.toString();
                    }
                    var reserve0 = nextPool.reserve0;
                    var reserve1 = nextPool.reserve1;
                    curRoute.push({
                        type: 'v2-pool',
                        tokenIn: {
                            chainId: tokenIn.chainId,
                            decimals: tokenIn.decimals,
                            address: tokenIn.address,
                            symbol: tokenIn.symbol,
                        },
                        tokenOut: {
                            chainId: tokenOut.chainId,
                            decimals: tokenOut.decimals,
                            address: tokenOut.address,
                            symbol: tokenOut.symbol,
                        },
                        reserve0: {
                            token: {
                                chainId: reserve0.currency.wrapped.chainId,
                                decimals: reserve0.currency.wrapped.decimals,
                                address: reserve0.currency.wrapped.address,
                                symbol: reserve0.currency.wrapped.symbol,
                            },
                            quotient: reserve0.quotient.toString(),
                        },
                        reserve1: {
                            token: {
                                chainId: reserve1.currency.wrapped.chainId,
                                decimals: reserve1.currency.wrapped.decimals,
                                address: reserve1.currency.wrapped.address,
                                symbol: reserve1.currency.wrapped.symbol,
                            },
                            quotient: reserve1.quotient.toString(),
                        },
                        amountIn: edgeAmountIn,
                        amountOut: edgeAmountOut,
                    });
                }
                routeResponse.push(curRoute);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (route_1_1 && !route_1_1.done && (_b = route_1.return)) _b.call(route_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var result = {
        methodParameters: methodParameters,
        blockNumber: blockNumber.toString(),
        amount: amount.quotient.toString(),
        amountDecimals: amount.toExact(),
        quote: quote.quotient.toString(),
        quoteDecimals: quote.toExact(),
        quoteGasAdjusted: quoteGasAdjusted.quotient.toString(),
        quoteGasAdjustedDecimals: quoteGasAdjusted.toExact(),
        gasUseEstimateQuote: estimatedGasUsedQuoteToken.quotient.toString(),
        gasUseEstimateQuoteDecimals: estimatedGasUsedQuoteToken.toExact(),
        gasUseEstimate: estimatedGasUsed.toString(),
        gasUseEstimateUSD: estimatedGasUsedUSD.toExact(),
        gasPriceWei: gasPriceWei.toString(),
        route: routeResponse,
        routeString: routeAmountsToString(route),
    };
    return result;
}
